import { Header } from "./Header";
import { Footer } from "./Footer";

export const PageShell = ({ children, testId }) => (
  <div className="flex min-h-screen flex-col" data-testid={testId}>
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export const GuideHero = ({ eyebrow, title, children, icon: Icon }) => (
  <section className="relative overflow-hidden border-b">
    <div className="grid-bg absolute inset-0 opacity-70" />
    <div className="relative mx-auto max-w-5xl px-4 py-14 sm:px-8 lg:py-20">
      <p className="eyebrow fade-up flex items-center gap-2 text-accent dark:text-primary">
        {Icon && <Icon className="h-4 w-4" />} {eyebrow}
      </p>
      <h1 className="fade-up delay-1 mt-4 max-w-3xl text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">{title}</h1>
      <div className="fade-up delay-2 mt-5 max-w-2xl text-base text-muted-foreground md:text-lg">{children}</div>
    </div>
  </section>
);
